import { render, staticRenderFns } from "./OfficePolicyForm.vue?vue&type=template&id=bd21fb1c&scoped=true&"
import script from "./OfficePolicyForm.vue?vue&type=script&lang=js&"
export * from "./OfficePolicyForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficePolicyForm.vue?vue&type=style&index=0&id=bd21fb1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd21fb1c",
  null
  
)

export default component.exports